import apiClient from '../../shared/services/apiClient';

/**
 * 邮件推送（TM）后台管理扩展 — 总览 / 风险事件 / 全站发送记录 / 发信域名 / API 密钥 / 发信流运维 / 全局设置 / 节点运维。
 * 后端路由 api/config/routes/tm_admin_ext.php；所有写操作记入 tm_admin_log。
 */
const BASE = '/api/admin/tm';

const call = async (p) => {
    try {
        const res = await p;
        return res.data;
    } catch (e) {
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { ...body, success: false, status: e?.response?.status, error: body.error || body.message || e?.message };
    }
};
const get = (url, params) => call(apiClient.get(`${BASE}${url}`, { params }));
const post = (url, data, cfg = {}) => call(apiClient.post(`${BASE}${url}`, data || {}, cfg));
const del = (url) => call(apiClient.delete(`${BASE}${url}`));

const tmAdminExtService = {
    overview: (params) => get('/overview', params),
    adminLog: (params) => get('/admin-log', params),
    risk: (params) => get('/risk', params),

    searchMessages: (params) => get('/messages', params),
    getMessage: (id) => get(`/messages/${id}`),

    listDomains: (params) => get('/domains', params),
    getDomain: (id) => get(`/domains/${id}`),
    verifyDomain: (id) => post(`/domains/${id}/verify`),
    disableDomain: (id, reason) => post(`/domains/${id}/disable`, { reason }),
    enableDomain: (id) => post(`/domains/${id}/enable`),
    deleteDomain: (id) => post(`/domains/${id}/delete`),

    listApiKeys: (params) => get('/api-keys', params),
    revokeApiKey: (id, reason) => post(`/api-keys/${id}/revoke`, { reason }),

    streamOps: (id) => get(`/streams/${id}/ops`),
    pause: (id, reason) => post(`/streams/${id}/ops/pause`, { reason }),
    resume: (id) => post(`/streams/${id}/ops/resume`),
    ban: (id, reason) => post(`/streams/${id}/ops/ban`, { reason }),
    unban: (id) => post(`/streams/${id}/ops/unban`),
    sandbox: (id, on, reason) => post(`/streams/${id}/ops/sandbox`, { on, reason }),
    setOverrides: (id, data) => post(`/streams/${id}/ops/overrides`, data),
    setType: (id, type, postalAddress) => post(`/streams/${id}/ops/type`, postalAddress === undefined ? { type } : { type, postal_address: postalAddress }),
    terminate: (id, confirm, reason) => post(`/streams/${id}/ops/terminate`, { confirm, reason }),

    getSettings: () => get('/settings'),
    saveSettings: (values) => post('/settings', { values }),

    nodeOps: (id) => get(`/nodes/${id}/ops`),
    updateNodeOps: (id, data) => post(`/nodes/${id}/ops/update`, data),
    rotateNodeSecret: (id) => post(`/nodes/${id}/ops/rotate-secret`),
    nodeHealth: (id) => post(`/nodes/${id}/ops/health`, {}, { skipGlobalErrorToast: true }),

    // 营销内容识别（api/docs/tm-marketing-classifier.md §10）
    mktSamples: (params) => get('/marketing/samples', params),
    mktSample: (id) => get(`/marketing/samples/${id}`),
    mktLabel: (id, label) => post(`/marketing/samples/${id}/label`, { label: label || null }),
    mktUpload: (files, label) => {
        const fd = new FormData();
        files.forEach((f) => fd.append('files[]', f));
        if (label) fd.append('label', label);
        return post('/marketing/samples/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
    },
    mktPaste: (data) => post('/marketing/samples/paste', data),
    mktDelete: (id) => del(`/marketing/samples/${id}`),
    mktStats: () => get('/marketing/stats'),
    mktSettings: () => get('/marketing/settings'),
    mktSaveSettings: (values) => post('/marketing/settings', { ...values, values }),
    mktRebuild: () => post('/marketing/model/rebuild'),
};

export default tmAdminExtService;
